import { Box, Button } from '@mui/material';
import { FaceIcon, ChatBubbleOutlineIcon } from '@/components/icons';

import { useAvatarSession } from './useAvatarSession';

type AvatarToggleProps = {
  /** When true, renders as a compact overlay chip (inside the avatar panel). */
  overlay?: boolean;
};

/**
 * Small chip that flips between "Show avatar" and "Text only".
 */
export function AvatarToggle({ overlay = false }: AvatarToggleProps) {
  const { avatarMode, enterAvatarMode, exitAvatarMode } = useAvatarSession();
  const Icon = avatarMode ? ChatBubbleOutlineIcon : FaceIcon;
  const label = avatarMode ? 'Text only' : 'Show avatar';

  const handleClick = () => {
    if (avatarMode) {
      exitAvatarMode('user_toggle');
    } else {
      enterAvatarMode();
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        ...(overlay ? {} : { px: 1.5, pt: 1 }),
      }}
    >
      <Button
        size="small"
        variant="outlined"
        startIcon={<Icon fontSize="small" />}
        onClick={handleClick}
        sx={{
          textTransform: 'none',
          borderRadius: 999,
          color: overlay ? 'common.white' : 'text.secondary',
          borderColor: overlay ? 'rgba(255,255,255,0.5)' : 'divider',
          bgcolor: overlay ? 'rgba(0,0,0,0.35)' : 'transparent',
          fontSize: 12,
          px: 1.5,
          py: 0.25,
          '&:hover': overlay
            ? { bgcolor: 'rgba(0,0,0,0.5)', borderColor: 'rgba(255,255,255,0.7)' }
            : undefined,
        }}
      >
        {label}
      </Button>
    </Box>
  );
}
